<template>
  <div>
    <SuccessfulPayment v-if="currentPayment.status == 'success'" :payment="currentPayment" />
    <FailedPayment v-else :payment="currentPayment" />
  </div>
</template> 

<script>

import FailedPayment from './FailedPayment'
import SuccessfulPayment from './SuccessfulPayment'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: "BillingPaymentsShow",

  components: { FailedPayment, SuccessfulPayment },

  props: {
    payment_id: {
      type: [Number, String],
      required: true,
    },
  },

  computed: {
    ...mapGetters("billing", ["currentPayment"])
  },

  methods: {
    ...mapActions("billing", ["loadCurrentPayment"]),
  },

  created() {
    const { payment_id } = this
    this.loadCurrentPayment({ payment_id });
  },
}
</script>
